import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, Icon, toast } from '@livable/saas-react-components';
import { Button, Link, Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ChangeNumber from 'src/components/settings/ChangeNumber';
import ChangeNumberModal from 'src/components/settings/ChangeNumberModal';
import { USER_SETTINGS_KEYS } from 'src/constants/userSetting';
import { useStore } from 'src/stores';
import { formatPhoneForDisplay } from 'src/utils/phone';
import useStyles from './styles';
const TwoFactorAuth = observer(() => {
  var _store$account$userPr;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const userPhone = (_store$account$userPr = store.account.userProfile.phone) !== null && _store$account$userPr !== void 0 ? _store$account$userPr : '';
  const _useState = useState(store.account.userProfile.mfaEnabled),
    _useState2 = _slicedToArray(_useState, 2),
    authIsEnabled = _useState2[0],
    setAuthIsEnabled = _useState2[1];
  const _useState3 = useState(store.account.userProfile.phoneConfirmed),
    _useState4 = _slicedToArray(_useState3, 2),
    phoneConfirmed = _useState4[0],
    setPhoneConfirmed = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isLoading = _useState6[0],
    setIsLoading = _useState6[1];
  const disableAccountMfa = async () => {
    const resp = await store.account.disableAccountMfaAsync.run();
    return resp;
  };
  const enableAccountMfa = async () => {
    const resp = await store.account.enableAccountMfaAsync.run();
    return resp;
  };
  const toggleAuthEnabling = () => {
    setIsLoading(true);
    setAuthIsEnabled(prevState => {
      if (!prevState) {
        enableAccountMfa().then(resp => {
          if (resp && resp.isSuccessful) {
            setPhoneConfirmed(true);
            localStorage.setItem(USER_SETTINGS_KEYS.phoneConfirmed, true);
            toast('success', {
              body: ['Two-factor authentication enabled']
            }); // ? i18n
          }
        }).finally(() => setIsLoading(false));
      } else {
        disableAccountMfa().then(resp => {
          if (resp && resp.isSuccessful) {
            localStorage.setItem(USER_SETTINGS_KEYS.phoneConfirmed, false);
            toast('success', {
              body: ['Two-factor authentication disabled']
            }); // ? i18n
          }
        }).finally(() => setIsLoading(false));
      }
      return !prevState;
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Paper, {
    variant: "formWrapper"
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    gutterBottom: true
  }, t('mfa.two_factor_auth')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "p",
    marginBottom: "18px"
  }, t('mfa.two_factor_auth_hint'), " ", /*#__PURE__*/React.createElement(Link, {
    href: "/"
  }, t('general.learn_more'))), /*#__PURE__*/React.createElement(Button, {
    disabled: !phoneConfirmed,
    fullWidth: true,
    onClick: toggleAuthEnabling,
    variant: "contained",
    'custom-attribute': '302-TwoFactorAuth'
  }, authIsEnabled ? t('general.disable') : t('general.enable'), " ", t('mfa.two_factor_auth').toLowerCase()), authIsEnabled && phoneConfirmed && /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.authFieldWrapper, " ").concat(classes.success)
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.authIcon
  }, /*#__PURE__*/React.createElement(Icon, {
    color: "success",
    fontSize: "large",
    type: "shield-check"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('mfa.two_factor_auth_enabled'))), phoneConfirmed ? /*#__PURE__*/React.createElement("div", {
    className: classes.verifiedMobile
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "phone"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, t('general.verified'), ": ", formatPhoneForDisplay(userPhone))), /*#__PURE__*/React.createElement(ChangeNumberModal, {
    phoneNumber: userPhone,
    setPhoneConfirmed: setPhoneConfirmed
  })) : /*#__PURE__*/React.createElement(ChangeNumber, {
    phoneNumber: userPhone,
    setPhoneConfirmed: setPhoneConfirmed
  })));
});
export default TwoFactorAuth;